export default "__VITE_ASSET__BYHCyZLY__"